import { useMemo } from 'react'
import { Body } from '@panwds/react-ui'
import { FileCertificateIcon, SitemapIcon, SensorIcon } from '@panwds/icons'
import { RightArrow } from '../../../common/assets/images'
import {
  WORKFLOW_ALLOCATE_LICENSE,
  WORKFLOW_CLAIM_LICENSE,
  WORKFLOW_CREATE_TENANT, WORKFLOW_NOTE_1, WORKFLOW_NOTE_2
} from '../constants/SubscriptionConstant'
import WorkFlowCard from './WorkFlowCard'


const WorkFlow = ({ showWorkFlow, ...props }) => {
  const getWorkFlowContent = useMemo(() => {
    return <div style={{ height: '177px' }} className={'tw-flex tw-flex-row tw-bg-gray-100 dark:tw-bg-gray-1050 tw-items-center tw-justify-center'}>
      <WorkFlowCard Icon={FileCertificateIcon} content={WORKFLOW_CLAIM_LICENSE}/>
      <div className="tw-px-6 tw-pb-8">
        <img src={RightArrow} alt="Right Arrow"/>
      </div>
      <WorkFlowCard Icon={SitemapIcon} content={WORKFLOW_CREATE_TENANT}/>
      <div className="tw-px-6 tw-pb-8">
        <img src={RightArrow} alt="Right Arrow"/>
      </div>
      <WorkFlowCard Icon={SensorIcon} content={WORKFLOW_ALLOCATE_LICENSE}/>
    </div>
  }, [])

  const getNonWorkFlowContent = useMemo(() => {
    return <div style={{ height: '112px' }} className={'tw-flex tw-flex-row tw-bg-gray-100 dark:tw-bg-gray-1050 tw-items-center tw-justify-center'}>
      <Body addClassName='tw-text-center' appearance='primary' size='md'>{WORKFLOW_NOTE_1} <br/> {WORKFLOW_NOTE_2}</Body>
    </div>
  }, [])

  return <>
    {showWorkFlow && getWorkFlowContent }
    {!showWorkFlow && getNonWorkFlowContent}
  </>
}
export default WorkFlow

